import { ImageScaleView, ImageScaleViewOpts } from '@play-co/timestep-core/ui';
import { FlexBoxView } from '@play-co/timestep-core/flexbox';
import { Match2GoalItem } from './Match2GoalItem';
import { GoalsDef } from '../game/defs/map';
import { GoalId } from '../game/defs/goal';
import { consolidateGoals } from '../match2.util';
import features from 'src/replicant/ruleset/features';
import { user } from 'src/StateObserver';

type Match2GoalsSummaryOpts = Omit<
  ImageScaleViewOpts,
  'image' | 'width' | 'height'
>;

export class Match2GoalsSummary extends ImageScaleView {
  private goalsContainer: FlexBoxView;
  private items: Match2GoalItem[] = [];

  constructor(opts: Match2GoalsSummaryOpts = {}) {
    const width = 494;
    const height = 138;
    super({
      image: 'assets/ui/match2/common/panel_sub_indent.png',
      width,
      height,
      centerOnOrigin: true,
      centerAnchor: true,
      scaleMethod: '9slice',
      sourceSlices: {
        horizontal: { left: 44, right: 44 },
        vertical: { top: 44, bottom: 44 },
      },
      ...opts,
    });

    const containerWidth = width - 15;
    const containerHeight = height - 20;

    this.goalsContainer = new FlexBoxView({
      superview: this,
      width: containerWidth,
      height: containerHeight,
      flex: {
        flexDirection: 'row',
        alignContent: 'center',
        justifyContent: 'space-evenly',
        flexWrap: 'wrap',
      },
      x: containerWidth * 0.5,
      y: containerHeight * 0.5,
      canHandleEvents: false,
      centerOnOrigin: true,
      centerAnchor: true,
    });
  }

  public setGoals(goals: GoalsDef, forceCompleted = false) {
    // If the new first 2 obstacle visuals feature is enabled, we need to determine if we should use the crate icon
    // for non-consolidated hatAll goals - since colored hats and parcels obstacles are consolidated
    // down into the hatAll that requires the original icon to be used.
    const useCrateIcon =
      features(user()).newFirst2ObstacleVisuals && goals.hatAll;

    this.goalsContainer.removeAllSubviews();
    goals = consolidateGoals(goals);

    for (const key in goals) {
      let item = this.items.find((item) => item.getParents().length === 0);

      if (!item) {
        item = new Match2GoalItem({
          scale: 1.5,
          countFontSize: 23,
          countOffsetX: -5,
          countOffsetY: 5,
        });
        this.items.push(item);
      }

      item.setGoal(
        key as GoalId,
        forceCompleted ? 0 : (goals[key as GoalId] as number),
        // Force apply crate icon for non-consolidated hatAll goals
        useCrateIcon && key === 'hatAll' ? 'icon.crate.png' : undefined,
      );
      this.goalsContainer.addSubview(item);
    }
  }
}
